// import React, { useState, useEffect } from "react";
// import API from "../axios";
// import "../style/incentive.css"

// import { motion } from "framer-motion";
// // import UnderDevelop from '../components/UnderDevelop';

// const Incentives = () => {

//   const [incData, setIncData] = useState([]);
//   const [salesIncData, setSalesIncData] = useState([]);
//   const [loading, setLoading] = useState(false);
//     const [showTop, setShowTop] = useState(false);

  
//   const empDetails = JSON.parse(localStorage.getItem("empDetails") || "{}");

//   const [isPreviousMonth, setIsPreviousMonth] = useState(false);

//   useEffect(() => {

//   const handleScroll = () => {

//     if (window.scrollY > 250) {

//       setShowTop(true);

//     } else {

//       setShowTop(false);
//     }
//   };

//   window.addEventListener("scroll", handleScroll);

//   return () => {
//     window.removeEventListener("scroll", handleScroll);
//   };

// }, []);


// const scrollToTop = () => {

//   window.scrollTo({
//     top: 0,
//     behavior: "smooth"
//   });

// };

//   const formatDate = (date) => {

//     const year = date.getFullYear();

//     const month = String(date.getMonth() + 1)
//       .padStart(2, "0");

//     const day = String(date.getDate())
//       .padStart(2, "0");

//     return `${year}-${month}-${day}`;
//   };



//   const fetchIncentives = async (previous = false) => 
//     { 
//       try 
//       { 
//         setLoading(true); 
//         const dates = previous ? getPreviousMonthDates() : getCurrentMonthDates(); 
//         const res = await API.post("/inc-subvalues", 
//           {
//              empcode: empDetails.employee_code, counter: empDetails.counter, bcode: empDetails.bcode, branch: empDetails.branchname, fromdate: dates.fromdate, todate: dates.tdate 
//           }); 

//           console.log(res.data);
//           setIncData(res.data); 
//       } 
//       catch (err) 
//       { 
//         console.error("Error fetching incentives", err); 
//       } 
//       finally 
//       { 
//         setLoading(false); 
//       } 
//     };

//       const fetchIncentivesSales = async (previous = false) => 
//     { 
//       try 
//       { 
//         setLoading(true); 
        
//         const dates = previous ? getPreviousMonthDates() : getCurrentMonthDates(); 
//         const res = await API.post("/inc-sales", 
//           {
//              empcode: empDetails.employee_code, counter: empDetails.counter, bcode: empDetails.bcode, branch: empDetails.branchname, fromdate: dates.fromdate, todate: dates.tdate 
//           }); 

//           console.log(res.data);
//           setSalesIncData(res.data); 
//       } 
//       catch (err) 
//       { 
//         console.error("Error fetching sales incentives", err); 
//       } 
//       finally 
//       { 
//         setLoading(false); 
//       } 
//     };



//     useEffect(() => 
//       { 
//         if (empDetails?.employee_code) 
//           { 
//             fetchIncentives(false); 
//             fetchIncentivesSales();
//           } 
//       }, []);
  
//     const handleMonthToggle = () => 
//       { 
//         const newState = !isPreviousMonth; 
//         setIsPreviousMonth(newState); 
//         fetchIncentives(newState); 
//         fetchIncentivesSales(newState);
//       };

//     const getCurrentMonthDates = () => { const now = new Date(); const firstDay = new Date( now.getFullYear(), now.getMonth(), 1 ); const lastDay = new Date( now.getFullYear(), now.getMonth() + 1, 0 ); return { fromdate: formatDate(firstDay), tdate: formatDate(lastDay) }; };
//     const getPreviousMonthDates = () => { const now = new Date(); const firstDay = new Date( now.getFullYear(), now.getMonth() - 1, 1 ); const lastDay = new Date( now.getFullYear(), now.getMonth(), 0 ); return { fromdate: formatDate(firstDay), tdate: formatDate(lastDay) }; };


//   return (
//     <div className='container mt-3'>

//          {
//   showTop && (

//     <motion.button
//       className="scrollTopBtn"
//       onClick={scrollToTop}

//       initial={{
//         opacity: 0,
//         scale: 0.5
//       }}

//       animate={{
//         opacity: 1,
//         scale: 1
//       }}

//       exit={{
//         opacity: 0,
//         scale: 0.5
//       }}

//       whileHover={{
//         scale: 1.1
//       }}

//       whileTap={{
//         scale: 0.9
//       }}
//     >

//       <i class="fa-solid fa-angles-up"></i>

//     </motion.button>
//   )
// }


//       <h4 className="mb-3 pageHeader text-center">Incentives</h4>

//       <div className='empdiv d-flex justify-content-between align-items-center gap-2'>
//           <div className='col-4'>
//               <label className="fw-bold">Emp Name :</label>
//             <input type='text' readOnly value={empDetails.emp_name || ""} className='form-control'></input>
//           </div>
//           <div className='col-4'>
//               <label className="fw-bold"> Counter :</label>
//             <input type='text' readOnly value={empDetails.counter || ""} className='form-control'></input>
//           </div>
//           <div className='col-4 d-flex justify-content-center'>
//               <button className='btn btn-sm btn-dark monthbtn ' onClick={handleMonthToggle} > { isPreviousMonth ? "Current Month" : "Previous Month" } </button>
//           </div>
//       </div>

//       <div className='subGrids mt-4'>

//           { loading ? <div className="text-center mt-4"> <p>Loading...</p> </div>
//            :
//             <div className="row g-3"> 
//             {/* TARGET TABLE */} 
//             <div className="col-md-4 col-6"> 
//               <div className="incCard shadow-sm"> 
//                 <table className="table table-bordered subtable mb-0 text-center"> 
//                   <thead> 
//                     <tr> 
//                       <th className="incHeader"> Cross Selling Target </th> 
//                     </tr> 
//                   </thead> 
//                   <tbody> 
//                     <tr> 
//                       <td className="incValue"> ₹ { incData?.targetData?.[0]?.incentvalue ? Number( incData.targetData[0].incentvalue ).toLocaleString("en-IN") : "0" } </td> 
//                     </tr> 
//                   </tbody> 
//                 </table> 
//               </div> 
//             </div> 
            
//             {/* ACHIEVED TABLE */} 
//             <div className="col-md-4 col-6"> 
//               <div className="incCard shadow-sm"> 
//                 <table className="table table-bordered subtable mb-0 text-center"> 
//                   <thead> 
//                     <tr> 
//                       <th className="incHeader"> Cross Selling Achieved </th> 
//                     </tr> 
//                   </thead> 
//                   <tbody> 
//                     <tr> 
//                       <td className="incValue"> ₹ { incData?.achievedData?.[0]?.grand_totalsales ? Number( incData.achievedData[0].grand_totalsales ).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00" } </td> 
//                     </tr> 
//                   </tbody> 
//                 </table> 
//               </div> 
//             </div> 


//               {/* PERCENTAGE TABLE */}

//           <div className="col-md-4 col-6">

//             <div className="incCard shadow-sm">

//               <table className="table table-bordered subtable mb-0 text-center">

//                 <thead>

//                   <tr>

//                     <th className="incHeader">
//                       Percentage
//                     </th>

//                   </tr>

//                 </thead>

//                 <tbody>

//                   <tr>

//                     <td className="incValue">

//                       {

//                         (() => {

//                           const target =
//                             incData?.targetData?.[0]?.incentvalue || 0;

//                           const achieved =
//                             incData?.achievedData?.[0]?.grand_totalsales || 0;

//                           const percentage =
//                             target > 0
//                               ? ((achieved / target) * 100).toFixed(2)
//                               : 0;

//                           return `${percentage}%`;

//                         })()

//                       }

//                     </td>

//                   </tr>

//                 </tbody>

//               </table>
//             </div>
//           </div>

//           </div> 
//           }

//       </div>

//       <div className="mainGrids mt-lg-4 mt-3">
        
//           <h4 class="pageHeader">Sales Incentive Details</h4>

    
//         <div className="salesIncDetails table-responsive">

//           <table className="table table-bordered align-middle text-center salesTable">

//             <thead>

//               <tr>

//                 <th>Counter</th>
//                 <th>Product</th>
//                 <th>Ach Wt</th>
//                 <th>Category</th>
//                 <th>Slab</th>
//                 <th>Inc Val</th>

//               </tr>

//             </thead>

//             <tbody>

//               {
//                 salesIncData?.salesIncData?.length > 0
//                 ?
//                 salesIncData.salesIncData.map((item, index) => (

//                   <tr key={index}>

//                     <td>{item.counter}</td>

//                     <td>{item.product}</td>

//                     <td>
//                       {
//                         Number(item.AcheivedWeight || 0)
//                         .toLocaleString("en-IN", {
//                           minimumFractionDigits: 2,
//                           maximumFractionDigits: 2
//                         })
//                       }
//                     </td>

//                     <td>{item.category}</td>

//                     <td>
//                       ₹ {
//                         Number(item.slab || 0)
//                         .toLocaleString("en-IN")
//                       }
//                     </td>

//                     <td className="fw-bold text-success">

//                       ₹ {
//                         Number(item.TotalIncentive || 0)
//                         .toLocaleString("en-IN")
//                       }

//                     </td>

//                   </tr>

//                 ))

//                 :

//                 <tr>

//                   <td colSpan="6" className="text-center py-4">
//                     No Sales Incentive Data Found
//                   </td>

//                 </tr>
//               }

//             </tbody>

//           </table>

//         </div>



//       </div>

//     </div>
//   )
// }

// export default Incentives



import React, { useState, useEffect } from "react";
import API from "../axios";
import "../style/incentive.css"

import { motion } from "framer-motion";
// import UnderDevelop from '../components/UnderDevelop';

const Incentives = () => {

  const [incData, setIncData] = useState([]);
  const [salesIncData, setSalesIncData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showTop, setShowTop] = useState(false);
  const [silveruser, setSilverUser] = useState("");

  
  const empDetails = JSON.parse(localStorage.getItem("empDetails") || "{}");

  const [isPreviousMonth, setIsPreviousMonth] = useState(false);

  useEffect(() => {

  const handleScroll = () => {

    if (window.scrollY > 250) {

      setShowTop(true);

    } else {

      setShowTop(false);
    }
  };

  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };

}, []);


const scrollToTop = () => {

  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });

};

  const formatDate = (date) => {

    const year = date.getFullYear();

    const month = String(date.getMonth() + 1)
      .padStart(2, "0");

    const day = String(date.getDate())
      .padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

const fetchIncentives = async (previous = false) => {
    try {
        setLoading(true);

        // Clear old data while loading
        setSalesIncData(null);

        const dates = previous
            ? getPreviousMonthDates()
            : getCurrentMonthDates();

        const res = await API.post("/incentives", {
            empcode: empDetails.employee_code,
            fromdate: dates.fromdate,
            todate: dates.tdate,
            bcode: empDetails.bcode
        });

        console.log("Incentives:", res.data);

        if (res.data?.success) {
            setSalesIncData(res.data);
            setSilverUser(res.data.counter);

        } else {
            setSalesIncData(null);
            setSilverUser("");
        }

    } catch (err) {
        console.error("Error fetching incentives:", err);
        setSalesIncData(null);
    } finally {
        setLoading(false);
    }
};


    useEffect(() => 
      { 
        if (empDetails?.employee_code) 
          { 
            fetchIncentives(false); 
          } 
      }, []);
  
    const handleMonthToggle = () => 
      { 
        const newState = !isPreviousMonth; 
        setIsPreviousMonth(newState); 
        fetchIncentives(newState); 
      };

    const getCurrentMonthDates = () => { const now = new Date(); const firstDay = new Date( now.getFullYear(), now.getMonth(), 1 ); const lastDay = new Date( now.getFullYear(), now.getMonth() + 1, 0 ); return { fromdate: formatDate(firstDay), tdate: formatDate(lastDay) }; };
    const getPreviousMonthDates = () => { const now = new Date(); const firstDay = new Date( now.getFullYear(), now.getMonth() - 1, 1 ); const lastDay = new Date( now.getFullYear(), now.getMonth(), 0 ); return { fromdate: formatDate(firstDay), tdate: formatDate(lastDay) }; };

const formatDate2 = (date) => {
    if (!date) return "-";

    const d = new Date(date);

    if (isNaN(d.getTime())) return "-";

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
};

  return (
    <div className='container mt-3'>

         {
  showTop && (

    <motion.button
      className="scrollTopBtn"
      onClick={scrollToTop}

      initial={{
        opacity: 0,
        scale: 0.5
      }}

      animate={{
        opacity: 1,
        scale: 1
      }}

      exit={{
        opacity: 0,
        scale: 0.5
      }}

      whileHover={{
        scale: 1.1
      }}

      whileTap={{
        scale: 0.9
      }}
    >

      <i class="fa-solid fa-angles-up"></i>

    </motion.button>
  )
}


      <h4 className="mb-3 mt-5 pageHeader text-center">Incentives</h4>

      <div className='empdiv d-flex justify-content-between align-items-center gap-2'>
          <div className='col-4'>
              <label className="fw-bold">Emp Name :</label>
            <input type='text' readOnly value={empDetails.emp_name || ""} className='form-control'></input>
          </div>

          {
            salesIncData?.counter &&
             <div className='col-4'>
                <label className="fw-bold"> Counter :</label>
                <input type='text' readOnly value={salesIncData?.counter || ""} className='form-control'></input>
            </div>

          }

        

          <div className='col-4 d-flex justify-content-center'>
              <button className='btn btn-sm btn-dark monthbtn ' onClick={handleMonthToggle} > { isPreviousMonth ? "Current Month" : "Previous Month" } </button>
          </div>
      </div>

          {loading ? (
              <div className="subGrids mt-4">
                  <div className="text-center py-4">
                      <div className="spinner-border spinner-border-sm me-2"></div>
                      Loading incentive details...
                  </div>
              </div>
          ) : salesIncData?.counter?.trim().toLowerCase() !== "silve" ? (
                <div className='subGrids mt-4'>

                  { loading ? <div className="text-center mt-4"> <p>Loading...</p> </div>
                  :
                    <div className="row g-3"> 
                    {/* TARGET TABLE */} 
                    <div className="col-md-3 col-6"> 
                      <div className="incCard shadow-sm"> 
                        <table className="table table-bordered subtable mb-0 text-center"> 
                          <thead> 
                            <tr> 
                              <th className="incHeader"> Selling Target </th> 
                            </tr> 
                          </thead> 
                          <tbody> 
                            <tr> 
                              <td className="incValue">{silveruser.trim().toLowerCase() == "silver" ? "" : "₹"}  { salesIncData?.personTarget ? Number( salesIncData.personTarget ).toLocaleString("en-IN") : "0" } {silveruser.trim().toLowerCase() == "silver" ? "g" : ""} </td> 
                            </tr> 
                          </tbody> 
                        </table> 
                      </div> 
                    </div> 
                    
                    {/* ACHIEVED TABLE */} 
                    <div className="col-md-3 col-6"> 
                      <div className="incCard shadow-sm"> 
                        <table className="table table-bordered subtable mb-0 text-center"> 
                          <thead> 
                            <tr> 
                              <th className="incHeader"> Selling Achieved </th> 
                            </tr> 
                          </thead> 
                          <tbody> 
                            <tr> 
                              <td className="incValue">{silveruser.trim().toLowerCase() == "silver" ? "" : "₹"} 
                                 {silveruser.trim().toLowerCase() == "silver" ? salesIncData?.totalWt ? Number( salesIncData.totalWt ).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00" : salesIncData?.totalAmount ? Number( salesIncData.totalAmount ).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00" } 
                                 {silveruser.trim().toLowerCase() == "silver" ? "g" : ""} </td> 
                            </tr> 
                          </tbody> 
                        </table> 
                      </div> 
                    </div> 


                      {/* PERCENTAGE TABLE */}

                    <div className="col-md-3 col-6">

                      <div className="incCard shadow-sm">

                        <table className="table table-bordered subtable mb-0 text-center">

                          <thead>

                            <tr>

                              <th className="incHeader">
                                Percentage
                              </th>

                            </tr>

                          </thead>

                          <tbody>

                            <tr>

                              <td className="incValue">

                                {

                                  (() => {

                                    const target =
                                      salesIncData?.personTarget || 0;

                                    const achieved = silveruser.trim().toLowerCase() ? salesIncData?.totalWt || 0 : salesIncData?.totalAmount || 0;

                                    const percentage =
                                      target > 0
                                        ? ((achieved / target) * 100).toFixed(2)
                                        : 0;

                                    return `${percentage}%`;

                                  })()

                                }

                              </td>

                            </tr>

                          </tbody>

                        </table>
                      </div>
                    </div>

                    {/* ACHIEVED TABLE */} 
                    <div className="col-md-3 col-6"> 
                      <div className="incCard shadow-sm"> 
                        <table className="table table-bordered subtable mb-0 text-center"> 
                          <thead> 
                            <tr> 
                              <th className="incHeader"> Inv Total </th> 
                            </tr> 
                          </thead> 
                          <tbody> 
                            <tr> 
                              <td className="incValue"> ₹ { salesIncData?.totalIncentive ? Number( salesIncData.totalIncentive ).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00" } </td> 
                            </tr> 
                          </tbody> 
                        </table> 
                      </div> 
                    </div> 


                  </div> 
                  }

              </div>

          ) : <div className="col-md-3 col-6 mt-3"> 
                      <div className="incCard shadow-sm"> 
                        <table className="table table-bordered subtable mb-0 text-center"> 
                          <thead> 
                            <tr> 
                              <th className="incHeader"> Inv Total </th> 
                            </tr> 
                          </thead> 
                          <tbody> 
                            <tr> 
                              <td className="incValue"> ₹ { salesIncData?.totalIncentive ? Number( salesIncData.totalIncentive ).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00" } </td> 
                            </tr> 
                          </tbody> 
                        </table> 
                      </div> 
                    </div> 
}

    
          {loading ? (
              <div className="subGrids mt-4">
                  <div className="text-center py-4">
                      <div className="spinner-border spinner-border-sm me-2"></div>
                      Loading incentive details...
                  </div>
              </div>
          ) : salesIncData?.salesIncData ? (

            <div className="mainGrids mt-lg-4 mt-3">
              
                <h4 class="pageHeader">Sales Incentive Details</h4>

          
              <div className="salesIncDetails table-responsive">

                <table className="table table-bordered align-middle text-center salesTable">

                  <thead>

                    <tr>
                      
                      <th>Date</th>
                      <th>Product</th>
                      <th>Ach Wt</th>
                      <th>Inc Val</th>

                    </tr>

                  </thead>

                  <tbody>

                    {
                      salesIncData?.salesIncData?.length > 0
                      ?
                      salesIncData.salesIncData.map((item, index) => (

                        <tr key={index}>

                          <td>{formatDate2(item.dat)}</td>
                          <td>{item.PRODUCT}</td>


                          <td>
                            {
                              Number(item.ITEMWGHT || 0)
                              .toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })
                            }
                          </td>


                          <td className="text-success">
                            ₹ {
                              Number(item.slab || 0)
                              .toLocaleString("en-IN",  {
                                                          minimumFractionDigits: 2,
                                                          maximumFractionDigits: 2
                                                        })
                            }
                          </td>

                          

                        </tr>

                      ))

                      :

                      <tr>

                        <td colSpan="6" className="text-center py-4">
                          No Sales Incentive Data Found
                        </td>

                      </tr>
                    }

                  </tbody>


                  <tfoot >
                    <tr className="fw-bold" >
                      <td colSpan="3" className="text-center bg-light">
                        Total
                      </td>

                      <td className="text-success bg-light">
                        ₹ {
                          salesIncData?.salesIncData?.reduce(
                            (total, item) => total + Number(item.slab || 0),
                            0
                          ).toLocaleString("en-IN",
                             {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                          )
                        }
                      </td>
                    </tr>
                  </tfoot>

                </table>

              </div>



            </div>
      
          ) : null}

    </div>
  )
}

export default Incentives


